'use es6';

export const CSS_CLASS = 'css_class';
export const CSS_ID = 'css_id';
export const CSS_ID_STR = 'css_id_str';
export const CSS_STYLE = 'css_style';
export const WRAPPING_HTML = 'wrapping_html';
export const PER_WIDGET_WRAPPER_HTML = 'per_widget_wrapper_html';